import { forwardRef } from 'react';

import * as DialogPrimitive from '@radix-ui/react-dialog';
import { twMerge } from 'tailwind-merge';

type Ref = HTMLDivElement;

function Dialog(props: DialogPrimitive.DialogProps) {
  return <DialogPrimitive.Root {...props} />;
}

const DialogContent = forwardRef<Ref, DialogPrimitive.DialogContentProps>(function DialogContent(props, ref) {
  return (
    <DialogPrimitive.DialogContent
      ref={ref}
      {...props}
      className={twMerge(
        'fixed left-2/4 top-2/4 z-50 -mt-8 w-11/12 -translate-x-2/4 -translate-y-2/4 rounded-md bg-white font-serif shadow-md focus:outline-none',
        'md:w-screen md:max-w-2xl',
        props.className,
      )}
    />
  );
});

const DialogOverlay = forwardRef<Ref, DialogPrimitive.DialogOverlayProps>(function DialogOverlay(props, ref) {
  return <DialogPrimitive.DialogOverlay ref={ref} {...props} className="fixed inset-0 z-50 bg-black/40 transition-opacity" />;
});

function DialogTitle({ className, ...props }: DialogPrimitive.DialogTitleProps) {
  return <DialogPrimitive.DialogTitle {...props} className={twMerge('m-0 text-lg font-medium text-neutral-900', className)} />;
}

function DialogDescription({ className, ...props }: DialogPrimitive.DialogDescriptionProps) {
  return <DialogPrimitive.DialogDescription {...props} className={twMerge('mb-5 text-sm leading-normal text-neutral-600', className)} />;
}

function DialogClose(props: DialogPrimitive.DialogCloseProps) {
  return <DialogPrimitive.DialogClose {...props} />;
}

Dialog.Content = DialogContent;
Dialog.Overlay = DialogOverlay;
Dialog.Title = DialogTitle;
Dialog.Description = DialogDescription;
Dialog.Close = DialogClose;

export { Dialog };
